export default "__VITE_ASSET__CDHtj9mc__"